import { gql } from '@apollo/client/core';

export const getInsurancesQuery = gql`
  query GetInsurances(
    $first: Int!
    $where: InsuranceCompanySearchResponseFilterInput
    $order: [InsuranceCompanySearchResponseSortInput!]
    $after: String
  ) {
    insuranceCompanies(
      first: $first
      where: $where
      order: $order
      after: $after
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        ediId
        formatType
        insuranceCode
        name
        recId
        recordStatus
        requiresEnrollment
      }
    }
  }
`;

export const getInsuranceQuery = gql`
  query GetInsurance($recId: Int!) {
    insuranceCompany(recId: $recId) {
      attachmentEnrollment
      attachments
      attachmentType
      claimFilingIndicator
      claimStatus
      claimStatusEnrollment
      claimStatusId
      claimStatusType
      contactEmail
      contactFax
      contactName
      contactPhone
      dateLastDbUpdate
      doesEligibility
      eligibilityEnrollment
      eligibilityType
      id
      insuranceCompanyCode
      lastNexiaOutputDate
      legacy
      name
      neicId
      nexia
      nexiaPayerMasterId
      notes
      payerState
      publishEra
      publishInstitutional
      publishProfessional
      realtimeId
      recId
      recordStatus
      webUrl
    }
  }
`;
